// Eliminar cliente: lógica pura (sin Angular) del motivo obligatorio que exige el servidor.
// El servidor lo lee del cuerpo en `motivo` (mínimo 5 caracteres) en reset-buro-all, reset-credit-internal y d-cli.
export const MOTIVO_MINIMO = 5;

export const validarMotivo = (motivo: any): string => {
  const limpio = String(motivo == null ? '' : motivo).trim();
  if (limpio.length === 0) return 'Escribe el motivo de la eliminación.';
  if (limpio.length < MOTIVO_MINIMO) return 'El motivo debe tener al menos 5 caracteres.';
  return '';
};

export const armarCuerpoEliminar = (client: any, motivo: any): any => {
  return { client: client, motivo: String(motivo == null ? '' : motivo).trim() };
};

export const mensajeErrorEliminar = (err: any): string => {
  const status = err && err.status;
  const texto = err && err.error && (err.error.msg || err.error.message);
  if (status === 403) return 'No tienes permiso para eliminar clientes.';
  if (status === 400) return texto ? String(texto) : 'Falta el motivo (5 caracteres o más).';
  if (status === 401) return 'Tu sesión venció. Vuelve a iniciar sesión.';
  return texto ? String(texto) : 'No se pudo eliminar el cliente. Inténtalo de nuevo.';
};
